// @ts-nocheck
import "../../sass/pages/_home-memes.scss";
import { generatorQr } from "../components/generatorQr";
import Loader from "../components/loader";
import Agegate from "../components/agegate";

import YouTubePlayer from "youtube-player";

import * as AOS from "aos";

import Swiper, { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

declare global {
  interface Window {
    drupalLogin: () => void;
    dataLayer: any;
    drupalSettings: any;
    player: YouTubePlayer;
  }
}

const loader = new Loader();
new Agegate();

window.addEventListener("load", () => {
  setTimeout(() => loader.hide(), 1000);
  //generatorQr()
  AOS.init({
    once: true,
    delay: 1000,
  });
  swiperRecetas();
  getAr();
  getTeam();
  hearAllBtns();
  stepsSwiper();
  beginBtnDatalayer();
  ARBtnDatalayer();
  memeBtnDatalayer();


  popUp();
});

function getVideoId(videoUrl: string) {
  if (videoUrl) {
    const match = videoUrl.match(
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
    );
    return match && match[7].length == 11 ? match[7] : false;
  }
}

const popUp = () => {
  const iframe = document.querySelector(
    ".popup #iframe-vid"
  ) as HTMLIFrameElement;
  const videoId = getVideoId(document.querySelector(".video-section")?.getAttribute("data-src") as string);
  const videoIdFirstVideo = getVideoId(document.querySelector(".section2")?.getAttribute("video-url") as string)
  const btnOpenPopUp = document.getElementById("play-btn");
  const btnOpenPopUpFirstVideo = document.querySelector(".section2");
  const btnClosePopUp = document.getElementById("close-btn");
  const overlayPopUp = document.getElementById("overlay");

  btnOpenPopUp?.addEventListener("click", () => {
    overlayPopUp?.classList.add("active");

    if (document.querySelector(".popup iframe")) {
      window.player.playVideo();
      return;
    }
    // iframe.src = videoUrl;

    window.player = YouTubePlayer("iframe-vid", {
      videoId: videoId,
    });

    setTimeout(() => {
      window.player.playVideo();
    }, 100);
  });

  btnClosePopUp?.addEventListener("click", () => {
    overlayPopUp?.classList.remove("active");
    window.player.stopVideo();
    window.player.destroy()
  });

  btnOpenPopUpFirstVideo?.addEventListener("click", () => {
    overlayPopUp?.classList.add("active");

    if (document.querySelector(".popup iframe")) {
      window.player.playVideo();
      return;
    }

    window.player = YouTubePlayer("iframe-vid", {
      videoId: videoIdFirstVideo,
    });

    setTimeout(() => {
      window.player.playVideo();
    }, 100);
  });

  // btnClosePopUp?.addEventListener("click", () => {
  //   overlayPopUp?.classList.remove("active");
  //   window.player.stopVideo();
  // });
};

const swiperRecetas = () => {
  const url = "/do-presidente-meme/main-recipes";

  fetch(url)
    .then(function (response) {
      return response.json();
    })
    .then(function (json) {
      json.forEach((data: any) => {
        const link = data.recipe_url;
        const name = data.recipe_title.substring(0, 12);
        const finalName = name + "";
        const urlImg = data.recipe_img_url;
        const urlImgDesk = data.recipe_img_urlDesktop;
        const ctnRecipe = document.createElement("a");
        ctnRecipe.classList.add("swiper-slide");
        ctnRecipe.setAttribute("id", "link-recipe");
        ctnRecipe.href = link;

        const picture = document.createElement("picture");
        picture.classList.add("destacada--img");

        const source = document.createElement("source");
        source.setAttribute("media", "(min-width: 1024px)");
        source.setAttribute("srcset", urlImgDesk);
        picture.appendChild(source);

        const img = document.createElement("img");
        img.classList.add("image");
        img.id = "img-recipe";
        img.src = urlImg;
        picture.appendChild(img);

        const infoDiv = document.createElement("div");
        infoDiv.classList.add("destacada--info");

        const titleDiv = document.createElement("div");
        titleDiv.classList.add("destacada--title");
        titleDiv.textContent = finalName;
        infoDiv.appendChild(titleDiv);

        const playImg = document.createElement("img");
        playImg.classList.add("destacada--play");
        playImg.setAttribute("height", "298");
        playImg.setAttribute("width", "326");
        playImg.setAttribute(
            "src",
            `${window.drupalSettings.path.themeUrl}/sources-memes/dist/img/home/Play.png`
        );
        playImg.setAttribute("alt", "platano power");
        playImg.setAttribute("title", "platano power");
        infoDiv.appendChild(playImg);

        ctnRecipe.innerHTML = "";
        ctnRecipe.appendChild(picture);
        ctnRecipe.appendChild(infoDiv);

        const getCtnForRecipes = document.querySelector("#ctn-recipes");
        getCtnForRecipes?.append(ctnRecipe);
      });
    });
};

const getAr = () => {
  let params = new URLSearchParams(document.location.search);
  let ar = params.get("ar");
  if (ar && ar == "true") window.drupalLogin();
};

const getTeam = () => {
  let params = new URLSearchParams(document.location.search);
  let team = params.get("target");
  if (team) {
    localStorage.setItem("team", team);
  }
};

function beginBtnDatalayer() {
  const btn = document.querySelector(".home-memes-presidente--btn#begin-btn");

  btn &&
    btn.addEventListener("click", (e: any) => {
      e.preventDefault();
      window.dataLayer.push({
        event: "GAEvent",
        event_category: "Content",
        event_action: "Content",
        event_label: "Comenzar",
        interaction: "true",
        component_name: "Comenzar",
        element_text: "Comenzar",
      });
    });
}

function ARBtnDatalayer() {
  const btn = document.querySelector(".home-memes-presidente--btn#AR-btn");

  btn &&
    btn.addEventListener("click", (e: any) => {
      e.preventDefault();
      window.dataLayer.push({
        event: "GAEvent",
        event_category: "Content",
        event_action: "Content",
        event_label: "Escanear lata",
        interaction: "true",
        component_name: "Escanear lata",
        element_text: "Escanear lata",
      });
    });
}

function memeBtnDatalayer() {
  const btnsCreateMeme = document.querySelectorAll(
    ".createMeme"
  );

  btnsCreateMeme.forEach(btn => {
    btn?.addEventListener("click", (e: any) => {
      window.dataLayer.push({
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': 'Content', 
        'event_label': 'Dale lata',
        'interaction':'true',
        'component_name': 'Comenzar',
        'element_text': 'Comenzar'
      
      });
    });
  });
}

function hearAllBtns() {
  const btns = document.querySelectorAll(".home-memes-presidente--btn");
  if (btns.length > 0) {
    btns.forEach((btn) => {
      btn?.addEventListener("click", () => {
        let linkTo: any = btn.getAttribute("linkto");
        if (btn.classList.contains("AR-btn")) {
          window.location.href = linkTo;
        } else {
          linkTo && validateRedirect(linkTo);
        }
      });
    });
  }
}

function validateRedirect(linkTo: string) {
  const isUser = window.drupalSettings.user.uid;
  isUser ? (window.location.href = linkTo) : window.drupalLogin();
}

function stepsSwiper() {
  if (document.querySelector("#homeMemesStepsSwiper")) {
    const swiper = new Swiper("#homeMemesStepsSwiper", {
      modules: [Pagination],
      slidesPerView: 1.5,
      spaceBetween: 32,
      centeredSlides: true,
      pagination: {
        el: ".home-memes-presidente--participar--steps .swiper-pagination",
        clickable: true,
      },
    });
  }
  setTimeout(() => {
    const swiperRecetas = new Swiper(".swiperRecetas", {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 32,
      breakpoints: {
        767: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30
        }
      }
    });
  }, 1500);
}
